<div class="grid-container">
    <div class="header">
      <app-header-mobile></app-header-mobile>
    </div>
    <div class="content">
      <router-outlet></router-outlet>
    </div>
  </div>
  